import type {
  CopyDayScheduleIn,
  CopyPreviousMonthSchedulesIn,
  CopyWeekSchedulesIn,
} from "@/pages/human-resources/time-management/endpoints/schedules-copy/inout/CopySchedulesIn.ts";
import axios from "axios";

export async function copyDaySchedule(input: CopyDayScheduleIn): Promise<void> {
  await axios.post(buildCopyUrlFor("day"), input);
}

export async function copyWeekSchedule(
  input: CopyWeekSchedulesIn,
): Promise<void> {
  await axios.post(buildCopyUrlFor("week"), input);
}

export async function copyPreviousMonthSchedule(
  input: CopyPreviousMonthSchedulesIn,
): Promise<void> {
  await axios.post(buildCopyUrlFor("month"), input);
}

function buildCopyUrlFor(rangeFragment: string): string {
  return `/api/hr/schedules/copy/${rangeFragment}`;
}
